import { Component, Input } from "@angular/core";

@Component({
  selector: "app-redirect-pending-approval",
  templateUrl: "./redirect-pending-approval.component.html",
  styleUrls: ["./redirect-pending-approval.component.scss"],
  standalone: false,
})
export class RedirectPendingApprovalComponent {
  @Input() supportEmail: string = "";
  @Input() mainMessage: string =
    "Your access request has not been approved yet.";
  @Input() subMessage: string =
    "Please try again later.. If the issue persists email us at";
}
